import { render, staticRenderFns } from "./Dotations.vue?vue&type=template&id=fbd5f4e6&"
import script from "./Dotations.vue?vue&type=script&lang=js&"
export * from "./Dotations.vue?vue&type=script&lang=js&"
import style0 from "./Dotations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports